export const os =
  typeof window !== 'undefined' &&
  window.navigator.platform.toUpperCase().includes('MAC')
    ? 'mac'
    : 'windows';
